import { useState } from "react";
import { Card, Icon } from "@mui/material";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

import BasicTable from "ui-components/tables/BasicTable";
import { ListLayout } from "ui-components/Layout";
import { Error } from "ui-components/Alert";
import { useCustomerValue } from "providers/CustomerContext";
import { TableCard } from "ui-components/Layout";
import { useTeamValue } from "providers/TeamContext";
import { getDivisionAdjustmentList } from "services/data.inventory.service";
import DivisionTransferDrawer from "./components/DivisionTransferDrawer";
import CheckboxTable2 from "ui-components/tables/CheckboxTable2";

function DivisionAdjustmentList() {
  const {permissions, allowAll} = useTeamValue();
  const { customerCode } = useCustomerValue();
  const navigate = useNavigate();
  const [alert, setAlert] = useState(null);
  const [dialog, setDialog] = useState(null);
  const [data, setData] = useState([]);
  const onError = (data) => setAlert(<Error data={data} onChange={setAlert} />);

  const addPermission = allowAll || (Boolean(permissions["Division Adjustment"]) && permissions["Division Transfer"].findIndex(b => b==="new") !== -1);

  useQuery({
    queryKey: ["division-adjustment-list", customerCode],
    queryFn: () => getDivisionAdjustmentList({ customerCode }),
    onSuccess: (data) => {
      setData(data.data.data);
    },
    onError,
  });

  const onNew = () => navigate("/inventory/division-adjustment/upload");

  const [sTransferRequest, setSTransferRequest] = useState(null);
  const [open, setOpen] = useState(false);
  const drawerProp = { open, setOpen, sTransferRequest, setSTransferRequest };
  const columns = [
    {
      header: "Stock Adjustment No",
      accessorKey: "stockTransferNo", 
      width: 250,
      cell: ({ row }) => {
        const { stockTransferNo } = row.original;
        console.log(stockTransferNo);
        return (
          <span
            style={{ color: "#1A73E8", cursor: "pointer", textDecoration: "underline" }}
            onClick={() => {
              setOpen(true);
              setSTransferRequest({ stockTransferNo, customerCode });
            }}
          >
            {stockTransferNo}
          </span>
        );
      },
    },
    { header: "Reason", accessorKey: "reason" },
    { header: "Created Date", accessorKey: "createdOn" },
    { header: "Created By", accessorKey: "createdBy" },
  ];

  return (
    <ListLayout>
      <DivisionTransferDrawer {...drawerProp} />
      {alert}
      {dialog}
      <TableCard sx={{my:3}}>
        <MDBox display="flex" justifyContent="space-between" margin="10px">
          <MDButton variant="gradient" color="info" disabled={!addPermission} onClick={onNew}>
            <Icon>upload</Icon>&nbsp;division&nbsp;adjustment
          </MDButton>
        </MDBox>
        <CheckboxTable2 columns={columns} data={data} />
      </TableCard>
    </ListLayout>
  );
}

export default DivisionAdjustmentList;
